import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Observable } from 'rxjs/Observable';
import { downloadUrl } from '../../../../utils/xhrDownloader';

import { SpectrogramData } from '../../models/spectrogramData';

@Injectable()
export class SpectrogramApiService {
    private spectrogramApi: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.spectrogramApi = this.configService.getEnv('spectrogramApi');
    }

    getSpectrogramData(jobId: string, date: Date): Observable<{} | SpectrogramData> {
        let url = this.spectrogramApi + jobId + '/' + this.formatDate(date);

        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                if (json) {
                    return new SpectrogramData(json);
                }
                return undefined;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getSpectrogramCsv(jobId: string, dates: Date[], filename: string) {
        let formattedDates = dates.map((date: Date) => this.formatDate(date));
        let url = this.spectrogramApi + jobId + '/csv';
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        headers.append('response-content', 'text/csv');
        let fullFileName = filename + '-spectrogram.csv';

        downloadUrl(url, formattedDates, fullFileName);
    }
    private formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }

        return [year, month, day].join('-');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/spectrogram/spectrogram.api.service.ts